import React from 'react'
import { trans } from '../../_providers/Translation'

// read-only version of AppliancesCategoriesPricing
function AppliancesCategoriesPricingPreview(props) {

    const prices = Array.isArray(props.prices) ? props.prices : []

    const getCurrency = c => {
        return c.currency?.name || props.currency || ''
    }

    return (
        <table className="collapsable-table">
            <thead>
                <tr>
                    <th>
                        {trans('tables.category')}
                    </th>
                    <th className="right" style={{ width: '130px' }}>
                        {trans('tables.price')}
                    </th>
                </tr>
            </thead>

            <tbody>
                {prices.map(c =>
                    <React.Fragment key={'price-' + c.id}>
                        <tr>
                            <td style={{ padding: '5px 20px', cursor: 'default' }}>
                                <span>
                                    {c.name}
                                    {c.default_price_formatted
                                        ?
                                        <>
                                            <br />
                                            {c.default_price_formatted} {getCurrency(c)}
                                        </>
                                        :
                                        ''
                                    }
                                </span>
                            </td>
                            <td className="right" style={{ padding: '5px 20px', width: '130px', cursor: 'default' }}>
                                {c.price_formatted} {getCurrency(c)}
                            </td>
                        </tr>
                        {Array.isArray(c.brands_prices) && c.brands_prices.length > 0 &&
                            <tr className="collapsable active">
                                <td colSpan="2" style={{ cursor: 'default' }}>
                                    <div className='pannel'>
                                        <table
                                            style={{
                                                cursor: 'default'
                                            }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {trans('tables.make')}
                                                    </th>
                                                    <th className="right" style={{ width: '130px' }}>
                                                        {trans('tables.price')}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {c.brands_prices.map(b =>
                                                    <tr key={'cbp-' + b.id}>
                                                        <td
                                                            style={{
                                                                background: "transparent",
                                                                cursor: 'default'
                                                            }}
                                                        >
                                                            {b.brand?.name}
                                                        </td>
                                                        <td
                                                            className="right"
                                                            style={{
                                                                width: '130px',
                                                                background: "transparent",
                                                                cursor: 'default'
                                                            }}
                                                        >
                                                            {b.price_formatted} {getCurrency(c)}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        }
                    </React.Fragment>
                )}
            </tbody>
        </table>
    )
}

export default AppliancesCategoriesPricingPreview
